import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { AITool } from './abstract-ai-tool';

@EnableClassTelemetry()
@Injectable()
export class AIToolService {
  tools: AITool[] = [];

  addTool(tool: AITool): void {
    this.tools.push(tool);
  }

  getSteps(): string {
    return this.tools.map((t) => `- ${t.label} (${t.description})`).join('\n');
  }

  getTools(): any[] {
    const res: any[] = [];
    this.tools.forEach((tool: AITool) => {
      const required: string[] = [];
      const properties: any = {};
      tool.properties?.forEach((p) => {
        if (p.required) {
          required.push(p.name);
        }
        const { name, type, description } = p;
        properties[name] = { type, description };
      });
      const fn: any = {
        name: tool.name,
        description: tool.description,
        toolSchema: {
          type: 'function',
          function: {
            name: tool.name,
            description: tool.description,
            parameters:
              Object.keys(properties).length > 0
                ? {
                    type: 'object',
                    properties,
                    required,
                  }
                : null,
          },
        },
      };
      res.push(fn);
    });
    return res;
  }
}
